export default function Future() {
    return (
        <div className="flex-row wrap">
            <ul>
                <li>Scheduled enable/disable of flags</li>
            </ul>
        </div>
    )
}